import type { FC } from "react";
import { BalanceBreakdownRow } from "web_myplann/Finances/Components/BalanceBreakdownRow";
import type { BalanceBreakdownEntry } from "web_myplann/Finances/Types/BalanceBreakdownEntry";

type Props = {
	entries: BalanceBreakdownEntry[];
};

export const BalanceBreakdownList: FC<Props> = ({ entries }) => (
	<>
		{entries.map((entry, index) => (
			<BalanceBreakdownRow
				key={entry.key}
				variant="item"
				label={entry.label}
				amount={entry.amount}
				isLast={index === entries.length - 1}
			/>
		))}
	</>
);
